<template>
  <MathAccordion :title="title">
    <p v-for="(val, key) in arResult" :key="key" class="text-2xl mb-3">
      <span v-for="(v, k) in val.data.operands" :key="k">
        {{ v }}
        <span v-if="k < val.data.operands.length - 1"> / </span>
      </span>
      =
      <span @click="changeVisible(key)" class="res">
        _
        <strong :class="arResult[key].resShow ? 'show' : 'hide'">
          {{ val.data.res }}
        </strong>
      </span>
    </p>
    <template #actions>
      <button
        type="button"
        class="px-4 py-2 text-sm font-medium text-blue-700 border border-blue-300 rounded hover:bg-blue-50 transition"
        @click="reloadTasks"
      >
        Перегенерировать
      </button>
    </template>
  </MathAccordion>
</template>

<script>
import MathAccordion from "@/Components/Math/MathAccordion.vue";
import { createErrorTask, generateDivisionTasks } from "@/lib/mathTasks";

export default {
  name: "AppDivision",
  components: {
    MathAccordion,
  },
  props: {
    arParams: Object,
  },
  data() {
    return {
      arResult: [],
      title: this.arParams.title,
    };
  },
  mounted() {
    this.reloadTasks();
  },
  methods: {
    changeVisible(key) {
      this.arResult[key].resShow = true;
    },
    reloadTasks() {
      const { tasks, exhausted } = generateDivisionTasks(this.arParams);
      this.arResult = exhausted
        ? [createErrorTask("Не удалось сгенерировать примеры для этого диапазона")]
        : tasks;
    },
  },
};
</script>
